import store from "../store/index";

const transferList = [
    // 商标相关
    { cn:'科凡全屋定制订单管理系统', en:'KEFAN Client Order Portal' },
    { cn:'科凡下单系统', en:'KEFAN Client Order Portal' },
    // 标题
    { cn:'订单系统', en:'OrderSystem' },
    { cn:'酷家乐', en:'Kujiale' },
    { cn:'设置', en:'Setting' },
    { cn:'登录', en:'Login' },
    { cn:'订单列表', en:'Regular Orders' },
    { cn:'我的户型库', en:'MyDesigns' },
    { cn:'售后单', en:'After-sales Orders' },
    { cn:'小样板单', en:'Sample Orders' },
    { cn:'成品单', en:'Finished Product Orders' },
    { cn:'店铺列表', en:'Clients' },
    { cn:'客户列表', en:'Customers' },
    { cn:'更新列表', en:'Update Logs' },
    { cn:'插件测试', en:'Plugins' },
    { cn:'新增子单', en:'Add Sub-order' },
    { cn:'新建子单', en:'Add Sub-order' },
    { cn:'酷家乐单', en:'Kujiale' },
    { cn:'酷家乐补单', en:'Kujiale' },
    { cn:'KD单', en:'KD' },
    { cn:'KD', en:'KD' },
    { cn:'CAD单', en:'CAD' },
    { cn:'CAD', en:'CAD' },
    { cn:'治木单', en:'ZhiMu' },
    { cn:'治木', en:'ZhiMu' },
    { cn:'其他', en:'Other' },
    { cn:'待选择区', en:'Unselected' },
    { cn:'选择区', en:'Selected' },
    { cn:'补单', en:'After-sales' },
    { cn:'新建售后单', en:'New After-sales Order' },
    { cn:'原单信息', en:'Original Order Details' },
    { cn:'售后单信息', en:'After-sales Order Details' },
    { cn:'编辑售后单', en:'Edit After-sales Order' },
    { cn:'新建正单', en:'New Regular Order' },
    { cn:'编辑正单', en:'Edit Regular Order' },
    { cn:'修改产品名称', en:'Edit Product Name' },
    { cn:'选择酷家乐客户单号', en:'Select Kujiale order number' },
    { cn:'新建售后单', en:'New After-Sale Order' },
    { cn:'新建成品单', en:'New Finished Product Order' },
    { cn:'编辑成品单', en:'Edit Finished Product Order' },
    { cn:'新建小样单', en:'New Sample Order' },
    { cn:'编辑小样单', en:'Edit Sample Order' },
    { cn:'商品详情', en:'Good Detail' },
    { cn:'商品介绍', en:'Good description' },
    { cn:'科凡优选商场', en:'Kefan Market' },
    { cn:'科凡优选家具商城', en:'Kefan Market' },
    { cn:'首页', en:'Index' },
    { cn:'搜索结果', en:'Search results' },
    { cn:'购物车', en:'Shopping Cart' },
    { cn:'当前单号：', en:'Current Order Number：' },
    { cn:'编辑明细', en:'Edit Order Bill' },
    { cn:'选择想要打开的方案', en:'Choose the design to open' },
    { cn:'酷家乐子单自动检测结果', en:'Sub-order detection result' },
    { cn:'检测结果', en:'Detection result' },
    { cn:'检测结果明细', en:'Detection result detail' },
    { cn:'已确认风险', en:'Risk Confirmed' },
    { cn:'主单主要产品需求汇总表', en:'Demand Summary' },
    { cn:'辅料确认表', en:'Auxiliary Material Summary' },
    { cn:'上次下单错误情况', en:'Last Order Placement Errors' },
    // 表单label
    { cn:'切换密码登录', en:'Login by password' },
    { cn:'切换扫码登录', en:'Login by scan' },
    { cn:'客户管理', en:'Customers Management' },
    { cn:'补单模式', en:'After-sales Order Mode' },
    { cn:'原单号', en:'Original Order Number' },
    { cn:'条码', en:'Barcode' },
    { cn:'下单单号', en:'Order Number' },
    { cn:'系统单号', en:'System Number' },
    { cn:'店铺', en:'Client' },
    { cn:'客户', en:'Customer' },
    { cn:'客户名称', en:'Customer Name' },
    { cn:'创建时间', en:'Create Date' },
    { cn:'最后修改时间', en:'Last modified time' },
    { cn:'下单状态', en:'Order Status' },
    { cn:'发货方式', en:'Delivery method' },
    { cn:'快递信息', en:'Express delivery information' },
    { cn:'设计师', en:'Designer' },
    { cn:'审核员', en:'Auditor' },
    { cn:'对单联系人', en:'Order tracking contact' },
    { cn:'对单人称呼', en:"Contact's title" },
    { cn:'对单人电话', en:"Contact's phone number" },
    { cn:'其他信息', en:'Other information' },
    { cn:'客户信息', en:'Customer information' },
    { cn:'客户', en:'Customer' },
    { cn:'产地', en:'Place of Origin' },
    // 表格表头
    { cn:'经销商编码', en:'Client Code' },
    { cn:'经销商', en:'Client' },
    { cn:'店名', en:'Client Name' },
    { cn:'门店联系方式', en:'Contact Information' },
    { cn:'门店收货地址', en:'Receiving Address' },
    { cn:'报价倍率', en:'Quotation Multiplier' },
    { cn:'能否下单', en:'Enable Place Order' },
    { cn:'序号', en:'No' },
    { cn:'客户姓名', en:'Customer' },
    { cn:'客户电话', en:'PhoneNumber' },
    { cn:'客户地址', en:'Customer Address' },
    { cn:'城市', en:'City' },
    { cn:'区号', en:'Area Code' },
    { cn:'操作', en:'Control' },
    { cn:'操作正单', en:'Control' },
    { cn:'操作子单', en:'Control' },
    { cn:'原单单号', en:'Original Order Number' },
    { cn:'酷家乐客户单号', en:'Kujiale Customer Number' },
    { cn:'酷家乐审核单号', en:'Kujiale Audit Number' },
    { cn:'店铺名称', en:'Client Name' },
    { cn:'店铺信息', en:'Client Infomation' },
    { cn:'客户名称', en:'Customer' },
    { cn:'单据类型', en:'Order Type' },
    { cn:'订单类型', en:'Order Type' },
    { cn:'商品类型', en:'Product Type' },
    { cn:'产品类型', en:'Product Type' },
    { cn:'正单状态', en:'Order Status' },
    { cn:'总报价', en:'Order Quotation' },
    { cn:'子单单号', en:'Sub-order Number' },
    { cn:'子单号', en:'Sub-order Number' },
    { cn:'子单状态', en:'Sub-order Status' },
    { cn:'序列', en:'Serial No' },
    { cn:'子单序列', en:'Serial No' },
    { cn:'产品名称', en:'Product Name' },
    { cn:'图纸类型', en:'Drawing type' },
    { cn:'标签颜色', en:'Label Color' },
    { cn:'灯系统状态', en:'Light-system Status' },
    { cn:'灯系统', en:'Light-system' },
    { cn:'系统检测', en:'Detection' },
    { cn:'子单报价', en:'Sub-order Quotation' },
    { cn:'拆单员', en:'Order Splitter' },
    { cn:'下单备注', en:'Order Remarks' },
    { cn:'其他', en:'Others' },
    { cn:'编码', en:'Code' },
    { cn:'名称', en:'Name' },
    { cn:'类型', en:'Type' },
    { cn:'规格', en:'Specification' },
    { cn:'单位', en:'Unit' },
    { cn:'数量', en:'Quantity' },
    { cn:'错误信息', en:'Error Info' },
    { cn:'涉及对象', en:'Related Object' },
    { cn:'错误标题', en:'Error Title' },
    { cn:'错误等级', en:'Error Level' },
    { cn:'检测规则', en:'Detection Rule' },
    { cn:'错误信息概览', en:'Error Description' },
    { cn:'风险确认', en:'Risk Confirm' },
    { cn:'工艺文档', en:'Tech Doc' },
    { cn:'已添加子单', en:'Added sub-orders' },
    { cn:'确认子单', en:'Sub-orders Confirm' },
    { cn:'类别', en:'Category' },
    { cn:'物料', en:'Material' },
    { cn:'辅料名', en:'Auxiliary material name' },
    // 按钮、Tag文本
    { cn:'设计学习网', en:'How to Design' },
    { cn:'门店', en:'ShposMgt' },
    { cn:'门店管理系统', en:'ShposMgt' },
    { cn:'帮助', en:'Help' },
    { cn:'工艺', en:'Technology' },
    { cn:'注销', en:'Logout' },
    { cn:'确认', en:'Confirm' },
    { cn:'确定', en:'Confirm' },
    { cn:'确认添加', en:'Confirm' },
    { cn:'确认下单', en:'Confirm' },
    { cn:'确认删除', en:'Confirm' },
    { cn:'确认并重新检测', en:'Confirm and re-detect' },
    { cn:'确认并下单', en:'Confirm and place order' },
    { cn:'取消', en:'Cancel' },
    { cn:'返回', en:'Back' },
    { cn:'手机号', en:'Phonenumber' },
    { cn:'密码', en:'Password' },
    { cn:'筛选', en:'Filter' },
    { cn:'保存倍率', en:'Save Multiplier' },
    { cn:'修改倍率', en:'Edit Multiplier' },
    { cn:'检测店铺可用', en:'Check Clients' },
    { cn:'编辑', en:'Edit' },
    { cn:'刷新', en:'Refresh' },
    { cn:'保存', en:'Save' },
    { cn:'隐藏', en:'Hide' },
    { cn:'显示', en:'Show' },
    { cn:'启动', en:'Operate' },
    { cn:'子单', en:'Sub-order' },
    { cn:'移出', en:'Remove' },
    { cn:'添加', en:'Add' },
    { cn:'搜索', en:'Search' },
    { cn:'未下单', en:'Not Ordered' },
    { cn:'下单中', en:'Placing' },
    { cn:'待受理', en:'Pending' },
    { cn:'已受理', en:'Accepted' },
    { cn:'已关闭', en:'Closed' },
    { cn:'已退单', en:'Refunded' },
    { cn:'已失效', en:'Invalidated' },
    { cn:'恢复', en:'Restore' },
    { cn:'删除', en:'Delete' },
    { cn:'关闭', en:'Close' },
    { cn:'开启', en:'Open' },
    { cn:'驳回', en:'Reject' },
    { cn:'移除', en:'Remove' },
    { cn:'打开', en:'Open' },
    { cn:'外部打开', en:'Outside' },
    { cn:'内部打开', en:'Inside' },
    { cn:'非系统内售后单', en:'New After-sales Order' },
    { cn:'上一步', en:'Previous Step' },
    { cn:'校验', en:'Verify' },
    { cn:'文件', en:'Files' },
    { cn:'设计方案', en:'Open Design' },
    { cn:'复制场景', en:'Copy Design' },
    { cn:'原单补', en:'After-sales Data' },
    { cn:'下单', en:'Place Order' },
    { cn:'重制', en:'Remake' },
    { cn:'撤销', en:'Undo' },
    { cn:'汇总', en:'Materials' },
    { cn:'补单表', en:'Details Form' },
    { cn:'更换设计师', en:'Change Designer' },
    { cn:'新设计', en:'New Design' },
    { cn:'检测通过', en:'Passed' },
    { cn:'拦截原因', en:'Error reason' },
    { cn:'检测中', en:'Detecting' },
    { cn:'检测失败', en:'Failed' },
    { cn:'同步', en:'Sync' },
    { cn:'已作废', en:'Discarded' },
    { cn:'已退回', en:'SendBacked' },
    { cn:'未提审', en:'Not submitted' },
    { cn:'待审核', en:'Pending review' },
    { cn:'审核中', en:'Under review' },
    { cn:'已通过', en:'Passed' },
    { cn:'请重试', en:'Try again' },
    { cn:'有变化', en:'Has changed' },
    { cn:'已保存', en:'Saved' },
    { cn:'延时', en:'delay' },
    { cn:'退单', en:'return' },
    { cn:'点击选择', en:'Click to select' },
    { cn:'选择', en:'Select' },
    { cn:'添加购物车', en:'Add to cart' },
    { cn:'详情', en:'Detail' },
    { cn:'增加/删除', en:'Add or Delete' },
    { cn:'下载', en:'Download' },
    { cn:'需求汇总表', en:'Demand Summary' },
    { cn:'酷家乐补单', en:'For Kujiale' },
    { cn:'条码补单', en:'For Barcode' },
    // 控件文本
    { cn:'一小时', en:'One Hour' },
    { cn:'一天', en:'One Day' },
    { cn:'三天', en:'Three Days' },
    { cn:'一周', en:'One Week' },
    { cn:'一个月', en:'One Month' },
    { cn:'三个月', en:'Three Months' },
    { cn:'半年', en:'Six Months' },
    { cn:'一年', en:'One Year' },
    { cn:'只看自己的订单', en:'My Orders' },
    { cn:'看所有订单', en:'All Orders' },
    { cn:'场景', en:'Drawing' },
    { cn:'三视图', en:'Three-view' },
    { cn:'附件', en:'Attachment' },
    { cn:'图纸', en:'Engineering' },
    { cn:'系统', en:'System' },
    { cn:'全部', en:'All' },
    { cn:'橱柜', en:'Cabinet' },
    { cn:'衣柜', en:'Closet' },
    { cn:'门窗', en:'Doors and windows' },
    { cn:'门墙', en:'Door&Wall' },
    { cn:'按修改时间', en:'Sort by modification time' },
    { cn:'按创建时间', en:'Sort by creation time' },
    { cn:'信息有误', en:'Wrong' },
    { cn:'不可下单', en:'Unable' },
    { cn:'可以下单', en:'Enable' },
    { cn:'可提交', en:'Submittable' },
    { cn:'不提交', en:'Do not submit' },
    { cn:'预览', en:'Preview' },
    { cn:'未处理', en:'Unprocessed' },
    { cn:'待确认', en:'Pending' },
    { cn:'有变化', en:'Modified' },
    { cn:'关键词', en:'Keyword' },
    { cn:'排序', en:'Sort' },
    // 提示信息    
    { cn:'成功', en:'Success' },
    { cn:'警告', en:'Warning' },
    { cn:'注意', en:'Warning' },
    { cn:'错误', en:'Error' },
    { cn:'K3标记', en:'K3 Mark' },
    { cn:'重要', en:'Important' },
    { cn:'其他', en:'Other' },
    { cn:'请选择商品类型', en:'Plase select product type' },
    { cn:'请选择下单店铺', en:'Plase select client' },
    { cn:'请输入原单单号!', en:'Plase input original order number!' },
    { cn:'请选择单据类型!', en:'Plase select order type!' },
    { cn:'请选择订单类型', en:'Plase select order type!' },
    { cn:'该酷家乐客户单没有关联的方案！', en:'There is no design associated with this Kujiale customer order.' },
    { cn:'选择打开方式', en:'Select opening method' },
    { cn:'请选择在系统内部打开或在系统外部打开：', en:'Please choose to open it inside the system or outside the system.' },
    { cn:'请选择设计师!', en:'Plase choose designer!' },
    { cn:'订单不存在！', en:'The order does not exist!' },
    { cn:'订单缺少店铺信息！', en:'Missing client info in the order!' },
    { cn:'选填，如不填，则以账号名称作为联系人称呼', en:"Optional. If left blank, the account name will be used as the contact's title." },
    { cn:'选填，如不填，则以账号登录手机号作为联系方式', en:"Optional. If left blank, the mobile phone number used for account login will be used as the contact's phone number." },
    { cn:'当前用户未绑定酷家乐账号，不能创建订单！', en:"The current user has not bound a KuJiale account and cannot create an order!"},
    { cn:'请输入更改后的名称：', en:'Please enter the new name:' },
    { cn:'请输入合法的产品名称', en:'Please enter a valid product name.' },
    { cn:'客户名、电话、地址', en:'Customer name, phone number, address' },
    { cn:'点击开始整单报价', en:'Click to start order quotation' },
    { cn:'点击开始报价', en:'Click to start quotation' },
    { cn:'报价完成，点击下载报价结果！', en:'Quotation completed. Click to download the quotation result!' },
    { cn:'报价中，请耐心等候。', en:'Quoting, please wait patiently.' },
    { cn:'取消报价', en:'Cancel quotation' },
    { cn:'报价失败。点击旁边的报价按钮可重新报价。', en:'Quotation failed. Click the quotation button to try again.' },
    { cn:'下载图纸', en:'Download the engineering drawing.' },
    { cn:'正在自动检测中，请稍候！', en:'Automatic detection in progress, please wait!' },
    { cn:'因网络等原因导致检测失败，请稍候点击【同步】重新检测！', en:'Detection failed due to network or other reasons. Please wait a moment and click the "Sync" button to detect again!' },
    { cn:'请选择报价格式', en:'Please select the file format.' },
    { cn:'请选择订单操作！', en:'Please select a order!' },
    { cn:'是否确认删除?', en:'Are you sure you want to delete?' },
    { cn:'是否确认下单?', en:'Are you sure you want to place order?' },
    { cn:'当前账号没有店铺信息！', en:'No client information is available for the current account!' },
    { cn:'该操作将会以当前订单的文件为基础，重新新建订单，更换新的单号。是否继续?', en:'This operation will create a new order based on the current order file and assign a new order number. Do you want to continue?' },
    { cn:'是否确定重新下单?', en:'Are you sure you want to reorder?' },
    { cn:'重新下单成功！', en:'Reorder successful!' },
    { cn:'选中订单没有子单！', en:'The selected order has no sub-orders!' },
    { cn:'订单提交中，请耐心等候！', en:'Order is being submitted, please wait patiently!' },
    { cn:'订单发送成功', en:'Order sent successfully' },
    { cn:'订单退单', en:'Order refund' },
    { cn:'订单发送失败', en:'Order failed to send' },
    { cn:'订单被提审', en:'Sub-order has been submitted' },
    { cn:'订单被认领', en:'Sub-order has been claimed' },
    { cn:'订单已通过', en:'Sub-order has been passed' },
    { cn:'订单被撤回', en:'Sub-order has been revoked' },
    { cn:'订单被驳回', en:'Sub-order has been rejected' },
    { cn:'订单被作废', en:'Sub-order has been cancelled' },
    { cn:'获取报价文件失败！尝试重新报价！', en:'Failed to obtain quotation file! Please try to quote again!' },
    { cn:'登记客户名', en:'Customer name in Kujiale order' },
    { cn:'登记客户电话', en:'Customer phonenumber in Kujiale order' },
    { cn:'请选择酷家乐单！', en:'Place select a Kujiale order!' },
    { cn:'家具物流五包服务（运输、中转、搬运、安装、售后）', en:'Furniture Logistics Five-in-One Service (transportation, transit, handling, installation, after-sales service)' },
    { cn:'正在加载中...', en:'Loading...' },
    { cn:'已经到底了', en:'No more' },
    { cn:'该子单不是酷家乐图纸！', en:'The Design dose not drawing by Kujiale!' },
    { cn:'请选择子单！', en:'Please choose a sub-order!' },
    { cn:'请用《科凡查单小程序》扫码登录', en:'Scan code to log in with KEFAN Mini Program' },
    { cn:'注：以上相关产品数据供检查参考，实际数据以下单为准（设计师提交下单文件的数据）', en:'Note: Product data above for reference only; actual data follows designer’s order file.' },
    { cn:'当前订单有审核单尚未添加到子单中，是否确认下单?', en:'Unadded audit orders exist. Confirm order submission?' },
    { cn:'订单总板件数不超过3件，不可下单！如确实有需要，请下售后单。', en:'≤3 panels: Cannot place order, create after-sales instead.' },
    { cn:'订单不能同时下 22厚的烤漆格栅（门楣）板 和 25厚的烤漆格栅（门楣）板。', en:'Cannot mix 22mm & 25mm painted grille lintel panels.' },
    { cn:'订单不能同时下 科凡LOGO门铰 和 库博门铰。', en:'KEFAN hinges and Blum hinges cannot coexist in one order.' },
    { cn:'请在上方确认添加的子单无误后，点击旁边的【确认】按钮，方可下单！', en:'Verify sub-orders first, click [Confirm] to submit order.' },
    { cn:'条码补单只适用于因运输导致的板件破损的补单。', en:'This mode is only applicable for reorders of panels damaged during transportation.' },
    { cn:'请输入条码！', en:'Plase input barcode!' },
    { cn:'您未关联原单所属店铺，请重新选择店铺。', en:'The client of the original order is not associated. Please reselect the store.' },
    { cn:'您没有原单客户的信息，请重新选择客户。', en:'Original order customer information not found. Please reselect the customer.' },
    // 其他
    { cn:'报价结果', en:'quotation result' },
    { cn:'创建于', en:'Created on' },
    { cn:'更新于', en:'Modified on' },
]

const i18n = {
    transfer(cn, en) {
        if (store.state.lang == 'zh-cn') return cn;
        else {
            if (en) return en;
            else {
                var fr = transferList.find(el=>el.cn==cn);
                if (fr) return fr.en;
                else return cn
            }
        }
    },
    install(app) {
        app.config.globalProperties.$t = this.transfer
    }
}

export default i18n